import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  saveLoading: false,
  disciplinaryMeasurementLength: 0,
  disciplinaryMeasurement: [],
  disciplinaryMeasurementError: "",
  formError: "",
};

export default function DisciplinaryMeasurementReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_DISCIPLINARY_MEASUREMENT:
      return { ...state, loading: action.payload };
    case actions.SAVE_LOADING_DISCIPLINARY_MEASUREMENT:
      return { ...state, saveLoading: action.payload };
    case actions.GET_DISCIPLINARY_MEASUREMENT:
      return {
        ...state,
        disciplinaryMeasurement: action.payload.disciplinaryMeasurement,
        disciplinaryMeasurementLength: action.payload.disciplinaryMeasurementLength,
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.DISCIPLINARY_MEASUREMENT_FAIL:
      return { ...state, disciplinaryMeasurementError: action.payload };
    default:
      return state;
  }
}
